const imageArchiveEnglish = {
  header: {
    title: "Image Archive",
    description: "Upload and manage images for your LinkedIn posts."
  },
  upload: {
    dragDrop: "Drag and drop images here",
    clickUpload: "or click to select images",
    uploading: "Uploading...",
    uploadButton: "Upload images",
    progress: "Upload progress"
  },
  gallery: {
    title: "My images",
    empty: "No images yet",
    uploadFirst: "Upload your first images above",
    imageActions: {
      copy: "Copy URL",
      delete: "Delete image"
    },
    deleteConfirm: "Are you sure you want to delete the image \"{name}\"?"
  },
  notification: {
    uploadSuccess: "{count} {count, plural, =1 {image} other {images}} uploaded to your image archive.",
    uploadTelegramSuccess: "Image uploaded to Telegram and ready to use in your posts",
    uploadTelegramFail: "The image is saved in your archive, but could not be sent to Telegram.",
    deleteSuccess: "The image has been deleted.",
    deleteFail: "An error occurred when deleting the image.",
    copySuccess: "Image URL copied to clipboard.",
    copyFail: "Could not copy URL.",
    generalError: "An error occurred. Please try again later."
  },
  customerBanner: "You are managing image archive for {customerName}",
  messages: {
    onlyImageFiles: "Only image files are allowed.",
    noValidUserId: "Could not find valid user ID."
  }
};

export default imageArchiveEnglish; 